import { FrontendAPIHelper } from "./FrontendAPIHelper";
import { FrontendBIM360Hub } from "./model/frontend/FrontendBIM360Hub";
import {
  GetAccessibleHubsResponse,
  GetHubProjectsResponse,
  GetProjectIssuesResponse,
  GetUserInfoResponse,
  GetProjectUsersResponse,
  GetProjectNGIssueTypesResponse,
  GetProjectIssueRootCausesResponse,
  GetProjectRolesResponse,
  GetProjectLocationsResponse,
  GetIssueAttributeDefinitionsResponse,
  GetCompaniesResponse,
  PostIssueCommentResponse,
  GetHubRolesIntersectionResponse,
  GetUserEntitlementsResponse,
  PutClientAssetMetadataResponse,
  PostProjectIssueResponse,
  GetModelSetsResponse,
  GetUserAccessInfoResponse,
  GetIssueActivitiesResponse,
  GetIssueActivitiesV2Response,
  GetSPFoldersResponse,
  GetSPSitesResponse,
  GetSPDrivesResponse,
  UploadFileToSPDriveResponse,
  UploadFileToSPDriveRequest,
  RegisterWebhookResponse,
  GetAutodeskDmFoldersResponse,
  GetAutodeskDmFolderContentsResponse,
  GetRegisteredWebhooksResponse,
  DeleteWebhookResponse,
  PostACCProjectRequestAccessResponse,
  PostACCDataConnectorProjectRolesJobRequest,
  GetHubACCProjectsResponse,
  GetHubACCUserProjectsResponse,
  GetACCProjectRolesListRequest,
  GetACCProjectRolesListResponse,
  PostACCProjectUserResponse,
  PostACCProjectUserRequestBody,
  PostBIM360ProjectUserRequestBody,
  GetUserModuleAccessResponse,
  GetProjectlistAccountSettingResponse,
  GetClientAssetMetadataResponseV2,
  GetUserPermissionForProjectAccessResponse,
  PostAccProjectUsersBulkImportRequestBody,
  PutBluebeamAccessCreateConnectionResponse,
  GetBluebeamAccessConnectionTokensResponse,
  DeleteBluebeamAccessConnectionResponse,
  DeleteBluebeamAccessConnectionRequest,
  GetBluebeamAccessConnectionRequest,
  GetBluebeamAccessConnectionResponse,
  DeleteBluebeamAccessTokensRequest,
GetHubUsersRequest,
  GetBluebeamAccessSettingsResponse,
} from "./api/APIRequests";
import { FrontendBIM360Project } from "./model/frontend/FrontendBIM360Project";
import { FrontendBIM360Issue } from "./model/frontend/FrontendBIM360Issue";
import { FrontendUserLicense } from "./model/frontend/FrontendUserLicense";
import { Loadable } from "./util/Loadable";
import { ForgeUser } from "./model/ForgeUser";
import { PaginationRequest } from "./util/PaginationParameters";
import { NGIssueTypeV2 } from "./model/BIM360NGIssueTypeV2";
import { Dictionary } from "vue-router/types/router";
import { BIM360IssueRootCauseCategories } from "./model/BIM360IssueRootCauseV2";
import cookie from "js-cookie";
import { ProjectRole } from "./model/ProjectRole";
import { BulkIssueTemplate } from "./model/frontend/BulkIssueTemplate";
import { ProjectLocation } from "./model/ProjectLocation";
import { BIM360IssueAttributeDefinition } from "./model/BIM360IssueAttributeDefinition";
import { BIM360Company } from "./model/BIM360Company";
import { head, keyBy } from "lodash";
import { FrontendBIM360IssueComment } from "./model/frontend/FrontendBIM360IssueComment";
import { FrontendBIM360IssueActivity } from "./model/frontend/FrontendBIM360IssueActivity";
import { FrontendBIM360IssueActivityV2 } from "./model/frontend/FrontendBIM360IssueActivityV2";
import { BIM360Modelset } from "./model/BIM360Modelset";
import { FrontendBIM360Modelset } from "./model/frontend/FrontendBIM360Modelset";
import {
  Settings,
  License,
  Metadata,
  SettingsHub,
  MetaDataHub,
  UserWithRole,
} from "./model/frontend/FrontendSettings";
import router from "./router/index";
import { SharePointSite } from "./sharepoint/SharepointAPI";
import { FrontendAutodeskDmFolder } from "./model/frontend/FrontendAutodeskDmFolder";
import { ACCProjectRequestAccess } from "./model/ACCProjectRequestAccess";
import { FrontendACCProject } from "./model/frontend/FrontendACCProject";
import { BackendACCRole } from "./model/backend/BackendACCRole";
import { FrontendBIM360ProjectServices } from "./model/frontend/FrontendBIM360ProjectServices";
import { FrontendACCProjectProducts } from "./model/frontend/FrontendACCProjectProducts";
import { DataConnectorCompany } from "./model/DataConnectorCompany";
import { ModuleItem } from "./model/backend/BackendBIMProjectRolesJob";
import { ERegion } from "./model/ERegion";

const api = new FrontendAPIHelper();

export class UIModel {
  public user: ForgeUser | null = null;
  public projectUsers: Dictionary<ForgeUser> | null = null;
  public projectRoles: Dictionary<ProjectRole> | null = null;
  public projectLocations: ProjectLocation[] = [];

  public modelSets: FrontendBIM360Modelset[] = [];

  public hubs = new Loadable(FrontendBIM360Hub, []);
  public selectedHub: FrontendBIM360Hub | null = null;
  public selectHubLoading: boolean = false;
  public companies: Dictionary<BIM360Company> | null = null;

  public projects = new Loadable(FrontendBIM360Project, []);
  public selectedProject: FrontendBIM360Project | null = null;

  public projectIssuesPageSize: number = 15;
  public projectIssues = new Loadable(FrontendBIM360Issue, [], "title");
  public projectFolders = new Loadable(FrontendAutodeskDmFolder, []);
  public projectNGIssueTypes: NGIssueTypeV2[] = [];
  public projectNGIssueTypesDict: Dictionary<NGIssueTypeV2> = {};

  public issueAttributeDefinitions: BIM360IssueAttributeDefinition[] = [];

  public projectRootCauseCategories: BIM360IssueRootCauseCategories[] = [];
  public newIssueTemplate = new BulkIssueTemplate(
    new FrontendBIM360Issue(),
    this
  );
  public newIssueCount: number = 1;
  public newIssueArray: FrontendBIM360Issue[] = [];
  public newIssueSuccesses: number = 0;
  public newIssueFailures: number = 0;
  public showCreateIssueOutcome = false;
  public accessToken: string | null = null;
  public issueCheckedRows: FrontendBIM360Issue[] = [];

  public issueComment: string = "";
  public issueIDsForComment: string[] = [];

  public settings: Settings = new Settings();

  public userLicenses: FrontendUserLicense[] = [];

  public accProjects = new Loadable(FrontendACCProject, [], "name");

  public accProjectRolesList: BackendACCRole[] = [];

  public userModules: ModuleItem[] = [];

  public userProjects: FrontendACCProject[] = [];

  public isProjectAccessAdmin: boolean = false;

  public constructor() {
    this.accessToken = cookie.get("access_token") as string;
    this.projectIssuesPageSize =
      parseInt(cookie.get("page_size") as string) || 15;
    this.projectIssues.pagination.pageSize =
      parseInt(cookie.get("page_size") as string) || 15;
    this.accProjects.pagination.pageSize = 15;
    //Remove default value in sortField for ACC API. Default value won't work.
    this.accProjects.sortField = "";
  }

  public logout(): void {
    window.location.href = "api/v1/logout";
    this.accessToken = null;
  }

  public login(): void {
    window.location.href = `/api/v1/auth`;
  }

  public msAuthLogin(): void {
    window.location.href = "/api/v1/msauth";
  }

  public autodeskLogin(state?: string): void {
    const query = state ? `?state=${encodeURIComponent(state)}` : ""; 
    window.location.href = `/api/v1/autodeskauth${query}`;
  }

  public bluebeamLogin(state?: string): void { 
    const query = state ? `?state=${encodeURIComponent(state)}` : ""; 
    window.location.href = `/api/v1/bluebeamauth${query}`; 
  }

  public async init() {
    // if(cookie.get('region')){
    //     let theRegion = (cookie.get('region') as ERegion);
    //     if(!theRegion) theRegion = ERegion.US;
    //     this.region = theRegion;
    // }

    try {
      let userInfoResponse = await api.callEndpoint(
        GetUserInfoResponse,
        "GET",
        "me",
        PaginationRequest.noPagination()
      );
      this.user = userInfoResponse.user;
    } catch (e) { }

    // Get User License info
    await this.getUserMenuAccess();
    await this.getUserEntitlements();

    if (cookie.get("autodesk_project_id")) {
      let projectId = cookie.get("autodesk_project_id") as string;
      let project = this.projects.getItemWithID(projectId);

      if (cookie.get("autodesk_hub_id")) {
        let hubId = cookie.get("autodesk_hub_id") as string;
        project.hubId = hubId;
      }

      if (cookie.get("autodesk_issue_container_id")) {
        let issueContainerId = cookie.get(
          "autodesk_issue_container_id"
        ) as string;
        project.issueContainerId = issueContainerId;
      }

      this.selectProject(project);
    }

    // Get Hubs
    this.getHubs();

    this.getUserAccessInfo();

    if (cookie.get("autodesk_hub_id")) {
      let hubId = cookie.get("autodesk_hub_id") as string;
      let hub = this.hubs.getItemWithID(hubId);
      this.selectHub(hub);
    }
  }

  public async getHubs() {
    await this.hubs.load(async (pagination: PaginationRequest) => {
      try {
        let response = await api.callEndpoint(
          GetAccessibleHubsResponse,
          "GET",
          "hubs",
          pagination
        );
        return { data: response.accessibleHubs };
      } catch (error) {
        console.log("Could not retrieve hubs.");
        return { data: [] };
      }
    });
  }

  // public async getACCProjects() {
  //   await this.accProjects.load(async (pagination: PaginationRequest) => {
  //     if (this.selectedHub) {
  //       try {
  //         // pagination.sortField = "";
  //         let response = await api.callEndpoint(GetHubACCProjectsResponse, 'GET', `acc/accounts/${this.selectedHub.id.replace(/^b\./, '')}/projects/${this.selectedProject?.id}/projects`, pagination);
  //         this.saveSelectHubAndPorjectCookies();
  //         return { data: response.projects, pagination: response.pagination };
  //       } catch (error) {
  //         console.log("Could not retrieve project issues.");
  //         return { data: [] };
  //       }
  //     }
  //     return { data: [] };
  //   });
  //   console.log(this.accProjects);
  // }

  public async getACCProjects() {
    await this.accProjects.load(async (pagination: PaginationRequest) => {
      console.log("pagination: ", pagination);
      if (this.selectedHub) {
        try {
          // pagination.sortField = "";
          let response = await api.callEndpoint(
            GetHubACCProjectsResponse,
            "GET",
            `acc/accounts/${this.selectedHub.id.replace(
              /^b\./,
              ""
            )}/projects?region=${this.selectedHub.region}`,
            pagination
          );
          this.saveSelectHubAndPorjectCookies();
          return { data: response.projects, pagination: response.pagination };
        } catch (error) {
          console.log("Could not retrieve project issues.");
          return { data: [] };
        }
      }
      return { data: [] };
    });
    console.log(this.accProjects);
  }

  public async getUserProjects() {
    try {
      if (!this.selectedHub) throw "Hub not selected.";
      let response = await api.callEndpoint(
        GetHubACCUserProjectsResponse,
        "GET",
        `acc/accounts/${this.selectedHub.id.replace(/^b\./, "")}/user/projects?region=${this.selectedHub.region}`,
        PaginationRequest.noPagination()
      );
      console.log("getUserProjects response: ", response);
      this.userProjects = response.projects;
    } catch (err) {
      console.log(err);
    }
  }

  private saveSelectHubAndPorjectCookies() {
    if (this.selectedHub?.id && this.selectedProject?.id) {
      let currentHubId = cookie.get("autodesk_hub_id");
      let currentProjectId = cookie.get("autodesk_project_id");
      if (
        this.selectedHub.id !== currentHubId ||
        this.selectedProject.id !== currentProjectId
      ) {
        let exp = new Date();
        exp.setSeconds(exp.getSeconds() + 1209600); // 14 days
        cookie.set("autodesk_hub_id", this.selectedHub.id, { expires: exp });
        cookie.set("autodesk_project_id", this.selectedProject.id, {
          expires: exp,
        });
      }
    }
  }

  private saveSelectHubCookies() {
    if (this.selectedHub?.id) {
      let currentHubId = cookie.get("autodesk_hub_id");
      if (this.selectedHub.id !== currentHubId) {
        let exp = new Date();
        exp.setSeconds(exp.getSeconds() + 1209600); // 14 days
        cookie.set("autodesk_hub_id", this.selectedHub.id, { expires: exp });
      }
    }
  }

  public async selectHub(hub: FrontendBIM360Hub): Promise<void> {
    this.selectHubLoading = true;
    this.issueCheckedRows = [];
    this.selectedHub = hub;
    await this.getProjects();
    console.log("router.currentRoute", router.currentRoute);
    if (router.currentRoute.name == "ProjectList") {
      this.initProjectListModule();
    } else if (router.currentRoute.name == "Settings") {
      // this.init();
      await this.getHubRolesIntersection();
    }
    this.saveSelectHubCookies();
    this.selectHubLoading = false;
  }

  public async getProjects() {
    await this.projects.load(async (pagination: PaginationRequest) => {
      if (this.selectedHub) {
        try {
          pagination.pageSize = 200;
          let response = await api.callEndpoint(
            GetHubProjectsResponse,
            "GET",
            `hubs/${this.selectedHub.id}/projects`,
            pagination
          );
          return { data: response.projects };
        } catch (error) {
          console.log("Could not retrieve project issues.");
          return { data: [] };
        }
      }

      return { data: [] };
    });

    // if (this.projects.data.length == 1) {
    //     await this.selectProject(this.projects.data[0]);
    // }
  }

  public async getProjectUsers() {
    if (this.selectedProject) {
      try {
        let response = await api.callEndpoint(
          GetProjectUsersResponse,
          "GET",
          `hubs/${this.selectedProject.hubId}/projects/${this.selectedProject.id}/users?region=${this.selectedHub?.region}`,
          PaginationRequest.noPagination()
        );
        this.projectUsers = keyBy(response.users, (u) => u.forgeID);
      } catch (error) {
        console.log("Could not retrieve project users.");
      }
    } else {
      return null;
    }
  }

  public async getCompanies() {
    if (this.selectedProject) {
      try {
        let response = await api.callEndpoint(
          GetCompaniesResponse,
          "GET",
          `hubs/${this.selectedProject.hubId}/projects/${this.selectedProject.id}/companies?region=${this.selectedHub?.region}`,
          PaginationRequest.noPagination()
        );
        this.companies = keyBy(response.companies, (c) => c.memberGroupId);
      } catch (error) {
        console.log("Could not retrieve companies.");
      }
    } else {
      return null;
    }
  }

  public async getProjectRoles() {
    if (this.selectedProject) {
      try {
        let response = await api.callEndpoint(
          GetProjectRolesResponse,
          "GET",
          `hubs/${this.selectedProject.hubId}/projects/${this.selectedProject.id}/roles?region=${this.selectedHub?.region}`,
          PaginationRequest.noPagination()
        );
        this.projectRoles = keyBy(response.roles, (r) => r.memberGroupId);
      } catch (error) {
        console.log("Could not retrieve project roles.");
      }
    } else {
      return null;
    }
  }

  public async getUserAccessInfo() {
    try {
      let response = await api.callEndpoint(
        GetUserAccessInfoResponse,
        "GET",
        `licenses`,
        PaginationRequest.noPagination()
      );
      console.log("getUserLicenses", response);
      this.userLicenses = response.licenses;
    } catch (error) {
      console.log("Could not retrieve project locations.");
    }
  }

  public async getProjectLocations() {
    if (this.selectedProject) {
      try {
        let response = await api.callEndpoint(
          GetProjectLocationsResponse,
          "GET",
          `hubs/${this.selectedProject.hubId}/projects/${this.selectedProject.id}/location-containers/${this.selectedProject.locationContainerId}/locations`,
          PaginationRequest.noPagination()
        );
        this.projectLocations = response.locations;
      } catch (error) {
        console.log("Could not retrieve project locations.");
      }
    } else {
      return null;
    }
  }

  public async getProjectNGIssueTypes() {
    if (this.selectedProject) {
      try {
        let response = await api.callEndpoint(
          GetProjectNGIssueTypesResponse,
          "GET",
          `hubs/${this.selectedProject.hubId}/projects/${this.selectedProject.id}/issue-containers/${this.selectedProject.issueContainerId}/issue-types`,
          PaginationRequest.noPagination()
        );
        this.projectNGIssueTypes = response.nGIssueTypes;
        this.projectNGIssueTypesDict = response.nGIssueTypesDict;
      } catch (error) {
        console.log("Could not retrieve project NG issue types.");
      }
    } else {
      return null;
    }
  }

  public async getProjectIssueRootCauses() {
    if (this.selectedProject) {
      try {
        let response = await api.callEndpoint(
          GetProjectIssueRootCausesResponse,
          "GET",
          `hubs/${this.selectedProject.hubId}/projects/${this.selectedProject.id}/issue-containers/${this.selectedProject.issueContainerId}/root-causes`,
          PaginationRequest.noPagination()
        );
        this.projectRootCauseCategories = response.rootCauseCategories;
      } catch (error) {
        console.log("Could not retrieve project root causes.");
      }
    } else {
      return null;
    }
  }

  public async getIssueAttributeDefinitions() {
    if (this.selectedProject) {
      try {
        let response = await api.callEndpoint(
          GetIssueAttributeDefinitionsResponse,
          "GET",
          `hubs/${this.selectedProject.hubId}/projects/${this.selectedProject.id}/issue-containers/${this.selectedProject.issueContainerId}/attribute-definitions`,
          PaginationRequest.noPagination()
        );
        this.issueAttributeDefinitions = response.issueAttributeDefinitions;
      } catch (error) {
        console.log("Could not retrieve issue attribute definitions.");
      }
    }
  }

  public async getModelSets() {
    if (this.selectedProject) {
      try {
        let response = await api.callEndpoint(
          GetModelSetsResponse,
          "GET",
          `hubs/${this.selectedProject.hubId}/containers/${this.selectedProject.id}/modelsets`,
          PaginationRequest.noPagination()
        );
        response.modelSets.map((m) => {
          if (this.selectedProject) {
            m.hubID = this.selectedProject.hubId;
            m.projectID = this.selectedProject.id;
          }
          return m.cloneMe();
        });
        this.modelSets = response.modelSets;
      } catch (error) {
        console.log("Could not retrieve model sets.");
      }
    }
  }

  public async updateModelSets() {
    if (this.selectedProject) {
      try {
        console.log(this.selectedProject);
        await api.callEndpoint(
          GetModelSetsResponse,
          "GET",
          `hubs/${this.selectedProject.hubId}/containers/${this.selectedProject.id}/modelsets`,
          PaginationRequest.noPagination()
        );
      } catch (error) {
        console.log("Could not update model sets.");
      }
    }
  }

  public async selectProject(project: FrontendBIM360Project) {
    this.issueCheckedRows = [];
    this.modelSets = [];
    this.selectedProject = project;
    // Get Settings info
    // this.getProjectLocations(); TODO: Turn on when Autodesk finally provide access to this
    if (router.currentRoute.name == "Issues") {
      this.initIssueModule();
    } else if (router.currentRoute.name == "Coordinate") {
      this.initCoordinateModule();
    } else if (router.currentRoute.name == "Sharepoint Doc Sync") {
      await this.initSpDocSyncModule();
    }
    // else if(router.currentRoute.name == "ProjectList") {
    //   this.initProjectListModule();
    // }
  }

  public async initIssueModule() {
    if (!this.selectedHub) {
      await this.getHubs();
    }
    this.getCompanies();
    this.getProjectNGIssueTypes();
    this.getProjectIssueRootCauses();
    this.getProjectRoles();
    this.getIssueAttributeDefinitions();
    this.getProjectUsers();
    this.projectIssues.clear();
    if (this.selectedProject)
      this.getIssues(
        this.selectedProject.hubId,
        this.selectedProject.id,
        this.selectedProject.issueContainerId
      );
  }

  public async initSpDocSyncModule() {
    if (!this.selectedHub) {
      await this.getHubs();
    }

    if (this.selectedProject) {
      await this.getProjectFolders(
        this.selectedProject.hubId,
        this.selectedProject.id
      );
    }
  }

  public async initCoordinateModule() {
    await this.getModelSets();
  }

  public async initProjectListModule() {
    await this.getUserPermissionForProjectAccess();
    await this.getACCProjects();
  }

  public async getProjectFolders(hubId: string, projectId: string) {
    await this.projectFolders.load(async (pagination: PaginationRequest) => {
      if (hubId && projectId) {
        try {
          let response = await api.callEndpoint(
            GetAutodeskDmFoldersResponse,
            "GET",
            `hubs/${hubId}/projects/${projectId}/topFolders`,
            PaginationRequest.noPagination()
          );
          if (response.autodeskDmFolders) {
            return {
              data: response.autodeskDmFolders,
              pagination: response.pagination,
            };
          } else {
            return { data: [] };
          }
        } catch (error) {
          console.log("Could not retrieve folders.");
        }
      }
      return { data: [] };
    });
  }

  public async getProjectFolderContents(projectId: string, folderURN: string) {
    if (projectId && folderURN) {
      try {
        let response = await api.callEndpoint(
          GetAutodeskDmFolderContentsResponse,
          "GET",
          `projects/${projectId}/folders/${encodeURIComponent(folderURN)}/contents`,
          PaginationRequest.noPagination()
        );
        return response.autodeskDmFolders || [];
      } catch (error) {
        console.log("Could not retrieve folder contents.");
        return [];
      }
    }
    return [];
  }

  public async getIssues(
    hubId: string,
    projectId: string,
    issueContainerId: string
  ) {
    await this.projectIssues.load(async (pagination: PaginationRequest) => {
      if (hubId && issueContainerId) {
        try {
          let response = await api.callEndpoint(
            GetProjectIssuesResponse,
            "GET",
            `hubs/${hubId}/projects/${projectId}/containers/${issueContainerId}/issues`,
            pagination
          );
          if (response.issues) {
            response.issues.map((s) => s.cloneMe());
            return { data: response.issues, pagination: response.pagination };
          } else {
            return { data: [] };
          }
        } catch (error) {
          console.log("Could not retrieve project issues.");
        }
      }
      return { data: [] };
    });
  }

  public async refreshIssuesData() {
    await this.projectIssues.load(async (pagination: PaginationRequest) => {
      if (
        this.selectedProject &&
        this.selectedProject.id &&
        this.selectedProject.issueContainerId
      ) {
        try {
          let response = await api.callEndpoint(
            GetProjectIssuesResponse,
            "GET",
            `hubs/${this.selectedProject.hubId}/projects/${this.selectedProject.id}/containers/${this.selectedProject.issueContainerId}/issues`,
            pagination.setPageSize(this.projectIssues.pagination.pageSize)
          );
          response.issues.map((s) => s.cloneMe());
          return { data: response.issues, pagination: response.pagination };
        } catch (error) {
          console.log("Could not refresh project issues.");
        }
      }

      return { data: [] };
    });
  }

  public async bulkCreateOrUpdateIssues(isNew: boolean) {
    if (!isNew) {
      //Update issue
      if (this.selectedProject) {
        for (const issue of this.newIssueArray) {
          issue.issueTypeId =
            this.projectNGIssueTypes.find((type) => {
              for (const subtype of type.subtypes) {
                if (subtype.id == issue.issueSubtypeId) {
                  return true;
                }
              }
              return false;
            })?.id || "";
          let updateObj = issue.generateUpdatedPropertiesObject();
          const value = await this.createOrUpdateSingleIssue(
            updateObj,
            this.selectedProject,
            isNew
          );
          // this.issueIDsForComment.push(value.forgeId);
        }
      }
      // this.newIssueArray = [];
      this.showCreateIssueOutcome = true;
      return;
    }

    // Iterates through each issue and sends a create request for each
    if (this.selectedProject) {
      for (const issue of this.newIssueArray) {
        const copy = JSON.parse(JSON.stringify(issue));
        copy.type =
          this.projectNGIssueTypes.find((type) => {
            for (const subtype of type.subtypes) {
              if (subtype.id == copy.subType) {
                return true;
              }
            }
            return false;
          })?.id || "";
        const keys = Object.keys(copy);
        for (const key of keys) {
          if (copy[key] == "" || copy[key] == null) {
            delete copy[key];
          }
        }
        const value = await this.createOrUpdateSingleIssue(
          copy,
          this.selectedProject,
          isNew
        );
        this.issueIDsForComment.push(value.forgeId);
      }

      // Send comments if they are provided
      if (this.issueComment !== "") {
        for (let issue of this.issueIDsForComment) {
          const body: FrontendBIM360IssueComment = {
            issue_id: issue,
            body: this.issueComment,
          };
          if (this.selectedProject) {
            this.addIssueComment(body, this.selectedProject);
          }
        }
        this.issueComment = "";
      }

      this.issueIDsForComment = [];
    }

    // // Only reload when the user approves the notification message
    // if (this.selectedHub && this.selectedProject) {
    //     await this.getIssues(this.selectedHub.id, this.selectedProject.id, this.selectedProject.issueContainerId);
    // }

    // Shows the summary notification in the UI, can be closed by clicking the button on the notification (could change to timed if it makes sense)
    this.showCreateIssueOutcome = true;
  }

  public async createOrUpdateSingleIssue(
    issue: FrontendBIM360Issue,
    project: FrontendBIM360Project,
    isNew: boolean
  ): Promise<any> {
    try {
      let response = await api.callEndpoint(
        PostProjectIssueResponse,
        isNew ? "POST" : "PATCH",
        `issues/containers/${project.issueContainerId}/quality-issues${
          isNew ? "" : `/${issue.forgeId}`
        }`,
        PaginationRequest.noPagination(),
        { issue: issue }
      );
      console.log(response.issue);
      this.newIssueSuccesses += 1;
      return response.issue;
    } catch (error) {
      console.log(error);
      this.newIssueFailures += 1;
    }
  }

  public async addIssueComment(
    comment: FrontendBIM360IssueComment,
    project: FrontendBIM360Project
  ): Promise<void> {
    try {
      let response = await api.callEndpoint(
        PostIssueCommentResponse,
        "POST",
        `issues/containers/${project.issueContainerId}/comments`,
        PaginationRequest.noPagination(),
        { comment: comment }
      );
      console.log(response.comment);
    } catch (error) {
      console.log(error);
    }
  }

  public async getHubRolesIntersection(): Promise<void> {
    try {
      // if (!this.selectedHub || !this.selectedProject)
      //   throw "selectedHub || selectedProject is undefined.";
      if (!this.selectedHub) throw "selectedHub is undefined.";
      let response = await api.callEndpoint(
        GetHubRolesIntersectionResponse,
        "GET",
        `hubs/${this.selectedHub.id}/hub-roles?region=${this.selectedHub.region}`,
        // `hubs/${this.selectedHub.id}/projects/${this.selectedProject.id}/hub-roles?region=${this.selectedHub.region}`,
        PaginationRequest.noPagination()
      );
      this.settings.hubs = response.hubs.map((hub: any) =>
        SettingsHub.fromJSON(hub)
      );
      // this.settings.hubs = response.hubs.map((hub: any) => {
      //     for (let project of hub.projects) {
      //         project.issueModuleEnabled = false;
      //         project.coordinateModuleEnabled = false;
      //     }
      //     return {...hub, issueModuleRole: null, coordinateModuleRole: null}
      // });
      console.log("this.settings.hubs", this.settings.hubs);

      if (this.settings.licenses.length) {
        for (const h of this.settings.hubs) {
          h.readSettingsFromLicenses(this.settings.licenses);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  public async getUserEntitlements(): Promise<void> {
    try {
      let response = await api.callEndpoint(
        GetUserEntitlementsResponse,
        "GET",
        `entitlements?email=${this.user?.email}`,
        PaginationRequest.noPagination()
      );
      console.log("getUserEntitlements", response);

      if (response.licenses && response.licenses.length > 0) {
        this.settings.is_allowed = true;
        this.settings.licenses = response?.licenses.map((l: any) =>
          License.fromJSON(l)
        );

        for (let entitlement of response.licenses) {
          if (!entitlement.metadata) {
            // Set to true to force a redirect to Settings on load.
            this.settings.action_required = false;
            break;
          }
        }
      }
    } catch (error) {
      console.log("getUserEntitlements error", error);
    }
  }

  public hasEntitlement(productCode: string): boolean {
      return this.settings?.licenses?.some(
          l => l.product_code === productCode
      ) ?? false;
  }

  public async uploadSettings(): Promise<void> {
    this.settings.uploadingSettings = true;
    try {
      console.log(`${this.settings.licenses.length} license available`);
      const filteredLicenses = this.adminRemoveDuplicatedLicenses(
        this.settings.licenses
      );
      console.log(`${filteredLicenses.length} license available`);
      for (let license of filteredLicenses) {
        console.log("license: ", license);
        let body: Metadata = {
          hubs: [],
        };
        for (let hub of this.settings.hubs) {
          let hub_metadata: MetaDataHub | null = null;
          const hub_copy = JSON.parse(JSON.stringify(hub));

          if (license.product_code) {
            hub_metadata = this.getMetadataHubData(
              hub_copy,
              license.product_code
            );
          }
          if (hub_metadata != null) {
            body.hubs.push(hub_metadata);
          }
        }
        console.log(license);
        let response = await api.callEndpoint(
          PutClientAssetMetadataResponse,
          "PUT",
          `/clients/${license.client_id}/assets/${license._id}/metadata`,
          PaginationRequest.noPagination(),
          body
        );
        console.log(response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.settings.uploadingSettings = false;
    }
  }

  public canSaveProjectAccess(license, selectHubId: string): boolean { 
    const projectProductCode = String( process.env.VUE_APP_PROJECT_LIST_PRODUCT_CODE ?? "" );
    if (license?.product_code !== projectProductCode) { 
      return false;
    } 
    const hubs = license?.metadata?.hubs ?? []; 
    const hubCount = hubs.length; 
    const seatCount = Number(license?.seats ?? 0);
    if (hubCount < seatCount) { 
      return true; 
    }
    if (hubCount === seatCount) {
      return hubs.some(h => h.hubId === selectHubId);
    }
    return false; 
  }

  private getMetadataHubData(
    hub: SettingsHub,
    productCode: string
  ): MetaDataHub | null {
    if (hub.id) {
      //Get selected role for the module
      let roleId = "";
      if (productCode == process.env.VUE_APP_ISSUE_PRODUCT_CODE) {
        roleId = String(hub.issueModuleRole?.roleId);
      } else if (productCode == process.env.VUE_APP_COORDINATE_PRODUCT_CODE) {
        roleId = String(hub.coordinateModuleRole?.roleId);
      } else if (productCode == process.env.VUE_APP_PROJECT_LIST_PRODUCT_CODE) {
        roleId = "";
      } else if (productCode == process.env.VUE_APP_SP_DOC_SYNC_PRODUCT_CODE) {
        roleId = String(hub.docSyncModuleRole?.roleId);
      }

      return {
        hubId: hub.id,
        roleId: roleId,
        allowedRoles: this.isProjectList(productCode) ? hub.projectListModuleRoles ?? [] : [],
        accProjectRolesList: [], //data saved by the sync job
        usersWithRoles: [], //data saved by the sync job
        companies: [], //data saved by the sync job
        ccEmails: this.isProjectList(productCode) ? hub.ccEmails ?? [] : [],
        allowedDomains: this.isProjectList(productCode) ? hub.allowedDomains ?? [] : [],
        region: hub.region,
        skipApprovalPage: this.isProjectList(productCode)
          ? hub.skipApprovalPage
          : false,
        defaultACCProjectRoles: this.isProjectList(productCode)
          ? hub.defaultACCProjectRoles
          : [],
        defaultACCProjectProducts: this.isProjectList(productCode)
          ? hub.defaultACCProjectProducts
          : new FrontendACCProjectProducts(),
        defaultBIM360ProjectServices: this.isProjectList(productCode)
          ? hub.defaultBIM360ProjectServices
          : new FrontendBIM360ProjectServices(),
        defaultCompany: this.isProjectList(productCode)
          ? hub.defaultCompany
          : null,
        projects: hub.projects
          .filter((project) => {
            if (productCode == process.env.VUE_APP_ISSUE_PRODUCT_CODE) {
              return project.issueModuleEnabled;
            } else if (
              productCode == process.env.VUE_APP_COORDINATE_PRODUCT_CODE
            ) {
              return project.coordinateModuleEnabled;
            } else if (
              productCode == process.env.VUE_APP_SP_DOC_SYNC_PRODUCT_CODE
            ) {
              return project.docSyncModuleEnabled;
            }
          })
          .map((project: any) => {
            return {
              id: project.id,
            };
          }),
      };
    }
    return null;
  }

  public isProjectList(productCode: string) {
    if (productCode == process.env.VUE_APP_PROJECT_LIST_PRODUCT_CODE) {
      return true;
    }
    return false;
  }

  public adminRemoveDuplicatedLicenses(licenses: License[]) {
    const output: License[] = [];
    for (const theLicense of licenses) {
      const found = output.find(
        (l) => l.product_code == theLicense.product_code
      );
      if (!found) output.push(theLicense);
    }
    console.log("output", output);
    return output;
  }

  public async sendAccProjectRequestAccess(input: ACCProjectRequestAccess) {
    const accountID = this.selectedHub?.id.replace(/^b\./, "");
    let response = await api.callEndpoint(
      PostACCProjectRequestAccessResponse,
      "POST",
      `acc/accounts/${accountID}/request-access`,
      PaginationRequest.noPagination(),
      input
    );
  }

  public async syncACCProjectRolesList() {
    const foundLicense = this.settings.licenses.find(
      (l) => l.product_code == process.env.VUE_APP_PROJECT_LIST_PRODUCT_CODE
    );
    if(!this.canSaveProjectAccess(foundLicense, String(this.selectedHub?.id))) {
      throw new Error("The number of hubs exceeds the number of licensed seats."); 
    }
    if (this.selectedHub && foundLicense) {
      const accountID = this.selectedHub.id.replace(/^b\./, "");
      let dataConnectProjectRolesResp = await api.callEndpoint(
        PostACCDataConnectorProjectRolesJobRequest,
        "POST",
        `data-connector/accounts/${accountID}/acc-project-roles`,
        PaginationRequest.noPagination(),
        {
          hubID: this.selectedHub.id,
          massifClientID: foundLicense.client_id,
          massifClientAssetID: foundLicense._id,
        }
      );
      console.log("dataConnectProjectRolesResp", dataConnectProjectRolesResp);
    }
  }

  public async getACCProjectRolesList() {
    const foundLicense = this.settings.licenses.find(
      (l) => l.product_code == process.env.VUE_APP_PROJECT_LIST_PRODUCT_CODE
    );
    if (this.selectedHub && this.selectedProject && foundLicense) {
      const accountID = this.selectedHub.id.replace(/^b\./, "");
      let accProjectRolesListResp = await api.callEndpoint(
        GetACCProjectRolesListResponse,
        "GET",
        `acc/accounts/${accountID}/projects/${this.selectedProject.id}/acc-project-roles`,
        PaginationRequest.noPagination()
      );
      this.accProjectRolesList = accProjectRolesListResp.accProjectRolesList;
      console.log("accProjectRolesListResp", accProjectRolesListResp);
    }
  }

  public setAccProjectRolesForHub(
    hubID: string,
    accProjectRoles: BackendACCRole[],
    usersWithRoles: UserWithRole[],
    companies: DataConnectorCompany[]
  ) {
    const theHub = this.settings.hubs.find((h) => h.id == hubID);
    if (theHub) {
      theHub.accProjectRolesList = accProjectRoles;
      theHub.usersWithRoles = usersWithRoles;
      theHub.companies = companies;
    }
  }

  public async addAccProjectUser(
    input: PostACCProjectUserRequestBody & {
      accountID: string;
      projectID: string;
    }
  ) {
    let accProjectUser = await api.callEndpoint(
      PostACCProjectUserResponse,
      "POST",
      `acc/accounts/${input.accountID}/projects/${input.projectID}/users`,
      PaginationRequest.noPagination(),
      input
    );

    console.log("accProjectUser", accProjectUser);
  }

  public async addBIM360ProjectUser(
    input: PostBIM360ProjectUserRequestBody & {
      accountID: string;
      projectID: string;
    }
  ) {
    let accProjectUser = await api.callEndpoint(
      PostACCProjectUserResponse,
      "POST",
      `bim360/accounts/${input.accountID}/projects/${input.projectID}/users`,
      PaginationRequest.noPagination(),
      input
    );
    console.log("accProjectUser", accProjectUser);
  }

  public async getIssueActivities(
    issue: FrontendBIM360Issue,
    project: FrontendBIM360Project
  ): Promise<any> {
    try {
      let responsev2 = await api.callEndpoint(
        GetIssueActivitiesV2Response,
        "GET",
        `issues/containers/${project.issueContainerId}/issues/${issue.forgeId}/activities`,
        PaginationRequest.noPagination()
      );
      return responsev2.activities.map((activity) => {
        return new FrontendBIM360IssueActivityV2(activity);
      });
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  public async getSharepointFolders(): Promise<any> {
    try {
      let spResponse = await api.callEndpoint(
        GetSPFoldersResponse,
        "GET",
        `sharepoint/folders`,
        PaginationRequest.noPagination()
      );
      return spResponse.folders;
    } catch (error) {}
  }

  public async getSharepointSites(): Promise<any> {
    try {
      let spResponse = await api.callEndpoint(
        GetSPSitesResponse,
        "GET",
        `sharepoint/sites`,
        PaginationRequest.noPagination()
      );
      return spResponse.sites;
    } catch (error) {}
  }

  public async getSharepointDrives(selectedSite: SharePointSite): Promise<any> {
    try {
      let spResponse = await api.callEndpoint(
        GetSPDrivesResponse,
        "GET",
        `sharepoint/sites/${selectedSite.id}/drives`,
        PaginationRequest.noPagination()
      );
      return spResponse.drives;
    } catch (error) {}
  }

  public async uploadFileToSPDrive(file: File, driveId: string): Promise<any> {
    try {
      const formData: FormData = new FormData();
      formData.append("file", file);

      const headers: Headers = new Headers();
      headers.append("Content-Type", "multipart/form-data");
      let spResponse = await api.callUploadEndpoint(
        UploadFileToSPDriveResponse,
        "PUT",
        `sharepoint/drives/${driveId}/upload`,
        formData,
        headers
      );
      return spResponse;
    } catch (error) {}
  }

  public async registerWebhook(
    region: ERegion,
    autodeskDmFolderId: string,
    autodeskHubName: string,
    autodeskProjectName: string,
    sharepointSiteName: string,
    sharepointDriveName: string,
    sharepointSiteId: string,
    sharepointDriveId: string
  ) {
    const headers: Record<string, string> = { "x-ads-region": region };
    let webhookRegisterResponse = await api.callEndpoint(
      RegisterWebhookResponse,
      "POST",
      "/webhooks/autodesk/register",
      PaginationRequest.noPagination(),
      {
        callbackUrl: process.env.VUE_APP_WEBHOOK_URL,
        scope: {
          folder: autodeskDmFolderId,
        },
        autoReactivateHook: true,
        hookAttribute: {
          autodeskHubName: autodeskHubName,
          autodeskProjectName: autodeskProjectName,
          sharepointSiteName: sharepointSiteName,
          sharepointDriveName: sharepointDriveName,
          msTenantId: this.msTenantId,
          sharepointSiteId,
          sharepointDriveId,
          region,
        },
      },
      headers
    );

    return webhookRegisterResponse;
  }

  public async registerWebhookForProjectAccess(
    region: ERegion,
    autodeskDmFolderId: string,
    autodeskAccountId: string,
    autodeskProjectId: string,
    autodeskProjectName: string,
    folderName: string
  ) {
    const headers: Record<string, string> = { "x-ads-region": region };
    let webhookRegisterResponse = await api.callEndpoint(
      RegisterWebhookResponse,
      "POST",
      "/webhooks/autodesk/register",
      PaginationRequest.noPagination(),
      {
        callbackUrl: `${process.env.VUE_APP_WEBHOOK_URL}/project-access`,
        // callbackUrl: `https://cb30-122-58-103-163.ngrok-free.app/webhooks/project-access`,
        scope: {
          folder: autodeskDmFolderId,
        },
        autoReactivateHook: true,
        hookAttribute: {
          region,
          autodeskAccountId,
          autodeskProjectId,
          autodeskProjectName,
          folderName,
          isProjectAccess: true,
          env: process.env.NODE_ENV
        },
        filter: "$[?(@.ext=='csv')]"
      },
      headers
    );

    return webhookRegisterResponse;
  }

  public async registerWebhookForBluebeamConnectInputFolder(
    region: ERegion,
    autodeskDmFolderId: string,
    autodeskAccountId: string,
    autodeskProjectId: string,
    autodeskProjectName: string,
    folderName: string,
    massifClientId: string,
    massifClientAssetId: string
  ) {
    const headers: Record<string, string> = { "x-ads-region": region };
    let webhookRegisterResponse = await api.callEndpoint(
      RegisterWebhookResponse,
      "POST",
      "/webhooks/autodesk/register",
      PaginationRequest.noPagination(),
      {
        callbackUrl: `${process.env.VUE_APP_WEBHOOK_URL}/formainput`,
        // callbackUrl: `https://dbfc-122-58-103-163.ngrok-free.app/webhooks/formainput`,
        scope: {
          folder: autodeskDmFolderId,
        },
        autoReactivateHook: true,
        hookAttribute: {
          region,
          autodeskAccountId,
          autodeskProjectId,
          autodeskProjectName,
          folderName,
          isBluebeamConnect: true,
          env: process.env.NODE_ENV,
          massifClientId,
          massifClientAssetId
        }
      },
      headers
    );

    return webhookRegisterResponse;
  }

  public async deleteWebhook(hookId: string, region: ERegion) {
    const headers: Record<string, string> = { "x-ads-region": region };
    let deleteWebhookResponse = await api.callEndpoint(
      DeleteWebhookResponse,
      "DELETE",
      `/webhooks/autodesk/${hookId}`,
      PaginationRequest.noPagination(),
      headers
    );
  }

  public async getRegisteredWebhooks(region: ERegion): Promise<any> {
    const headers: Record<string, string> = { "x-ads-region": region };
    let getRegisteredWebhooksResponse = await api.callEndpoint(
      GetRegisteredWebhooksResponse,
      "GET",
      "webhooks/autodesk",
      PaginationRequest.noPagination(),
      headers
    );

    return getRegisteredWebhooksResponse;
  }

  public get msTenantId(): string {
    const value = document.cookie.match(/ms_tenant_id\s*=\s*([^;]+)/);
    const token = value ? decodeURIComponent(value[1]) : "";
    return token;
  }

  public get accountID(): string | null {
    if (!this.selectedHub?.id) return null;
    return this.selectedHub.id.replace(/^b\./, "");
  }

  public accProductKeyFormat(input: string) {
    let result = input[0].toUpperCase();
    for (let i = 1; i < input.length; i++) {
      if (input[i] >= "A" && input[i] <= "Z") {
        result += " ";
      }
      result += input[i];
    }
    return result;
  }

  public bim360ServiceNameFormat(input: string) {
    let words = input.split("_");
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].slice(1);
    }
    return words.join(" ");
  }

  hasLicense(productCode: string): boolean {
    const found = this.userModules.find(m => m.toString() == productCode);
    if (found) return true;
    return false;
  }

  public async getUserMenuAccess(): Promise<any> {
    try {
      let response = await api.callEndpoint(
        GetUserModuleAccessResponse,
        "GET",
        `users/${this.user?.forgeID}/access`,
        PaginationRequest.noPagination()
      );
      this.userModules = response.modules;
    } catch (error) {
      console.log(error);
    }
  }

  public async getUserPermissionForProjectAccess() {
    // Only admin and users listed in ccEmail are allowed to use User and Project import features
    try {
        if (!this.selectedHub) throw "Hub not selected.";
        const accountID = this.selectedHub?.id.replace(/^b\./, "");
        let response = await api.callEndpoint(
          GetUserPermissionForProjectAccessResponse,
          "GET",
          `users/${this.user?.forgeID}/accounts/${accountID}/project-access/user-permission`,
          PaginationRequest.noPagination()
        );
        this.isProjectAccessAdmin = response.isAdmin;
    } catch (error) {
      console.log(error);
    }
  }

  public async getProjectlistSetting(accountID: string): Promise<any> {
    try {
      let response = await api.callEndpoint(
        GetProjectlistAccountSettingResponse,
        "GET",
        `projectlist/${accountID}/setting`,
        PaginationRequest.noPagination()
      );
      return response.setting;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  public async importProjectUsersFromFile(projectType: "ACC" | "BIM360", data: PostAccProjectUsersBulkImportRequestBody) {
    if(projectType == "ACC") {
      return await this.importAccProjectUsers(data);
    }
  }

  public async importAccProjectUsers(
    input: PostAccProjectUsersBulkImportRequestBody
  ) {
    if (!this.selectedHub) throw "Hub not selected.";
    const accountID = this.selectedHub?.id.replace(/^b\./, "");
    let result = await api.callEndpoint(
      PostACCProjectUserResponse,
      "POST",
      `acc/accounts/${accountID}/projects/users-import?region=${this.selectedHub.region}`,
      PaginationRequest.noPagination(),
      input
    );
    console.log("accProjectUsers", result);
    return result;
  }

  public async saveSettings(clientID: string, clientAssetID: string, productCode: string, body: any, mode: 'merge' | 'sync' = 'merge') {
    const obj =   {
        ...body,
        productCode,
        mode,
      };

    console.log(obj);
    let response = await api.callEndpoint(
      PutClientAssetMetadataResponse,
      "PUT",
      `/clients/${clientID}/assets/${clientAssetID}/productcode/${productCode}/metadatav2?mode=${mode}`,
      PaginationRequest.noPagination(),
      body
    );
  }

  
  public async getClientAssetMetadata(clientID: string, assetID: string): Promise<any> {
    try {
      let response = await api.callEndpoint(
        GetClientAssetMetadataResponseV2,
        "GET",
        `clients/${clientID}/assets/${assetID}/metadatav2`,
        PaginationRequest.noPagination()
      );
      return response.metadata;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  public async createBluebeamConnection(data: { projectName: string, connectionId: string, massifClientId: string, massifClientAssetId: string, webhookCallbackUrl: string, } ): Promise<any> {
    console.log("createBluebeamConnection data", data);
    return await api.callEndpoint(
          PutBluebeamAccessCreateConnectionResponse,
          "PUT",
          `bluebeam-access/connections`,
          PaginationRequest.noPagination(),
          {
              projectName: data.projectName,
              connectionId: data.connectionId,
              massifClientAssetId: data.massifClientAssetId,
              massifClientId: data.massifClientId,
              webhookCallbackUrl: data.webhookCallbackUrl
          }
      );
  }

  public async getBluebeamAccessTokens(clientAssetId: string, connectionId: string, vendor: "bluebeam" | "forma"): Promise<any> {
    try {
      let response = await api.callEndpoint(
        GetBluebeamAccessConnectionTokensResponse,
        "GET",
        `bluebeam-access/assets/${clientAssetId}/vendors/${vendor}/connections/${connectionId}/tokens`,
        PaginationRequest.noPagination()
      );
      if (response && response.accessToken) {
        return response;
      }
      return null;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  public async deleteBluebeamAccessLogin(clientAssetId: string, connectionId: string, vendor: "bluebeam" | "forma"): Promise<any> {
    let response = await api.callEndpoint(
      DeleteBluebeamAccessConnectionResponse,
      "DELETE",
      `bluebeam-access/assets/${clientAssetId}/vendors/${vendor}/connections/${connectionId}/tokens`,
      PaginationRequest.noPagination()
    );
    return response;
  }

  public async getBluebeamAccessConnection(clientAssetId: string, connectionId: string): Promise<any> {
    let response = await api.callEndpoint(
      GetBluebeamAccessConnectionResponse,
      "GET",
      `bluebeam-access/assets/${clientAssetId}/connections/${connectionId}`,
      PaginationRequest.noPagination()
    );
    return response;
  }

  public async deleteBluebeamAccessConnection(clientAssetId: string, connectionId: string): Promise<any> {
    let response = await api.callEndpoint(
      DeleteBluebeamAccessConnectionResponse,
      "DELETE",
      `bluebeam-access/assets/${clientAssetId}/connections/${connectionId}`,
      PaginationRequest.noPagination()
    );
    return response;
  }

  public async getAccAccountUsers(): Promise<ForgeUser[]> {                                                                                            
    let allUsers: ForgeUser[] = [];                                                                                                                    
    let pageNumber = 0;                                                                       
    const pageSize = 100;                                                                                                                              
    let hasMore = true;                                                                                                                                
                                                                                                                                                      
    while (hasMore) {                                                                                                                                  
      const pagination = new PaginationRequest();                                                                                                      
      pagination.enablePagination = true;                                                                                                              
      pagination.pageSize = pageSize;                                                                                                                  
      pagination.pageNumber = pageNumber;                                                                         
                                                                                                                                                      
      let response = await api.callEndpoint(                                                                                                           
        GetProjectUsersResponse,                                                                                                                       
        "GET",                                                                                                                                         
        `acc/accounts/${this.accountID}/users?region=${this.selectedHub?.region}`,                                                                     
        pagination                                                                                                                                     
      );                                                                                                                                            
                                                                                                                                                      
      if (response.users && response.users.length > 0) {                                                                                               
        allUsers.push(...response.users);                                                                                                              
        pageNumber += 1;                                                                                                  
        hasMore = response.users.length === pageSize;                                                                                                  
      } else {                                                                                                                                         
        hasMore = false;                                                                                                                               
      }                                                                                                                                                                                                                                                                                      
      await new Promise((resolve) => setTimeout(resolve, 10));                                                                                         
    }                                                                                                                                                  
    return allUsers;                                                                                                                                   
  }                            

  public async getBluebeamaccessSettings(): Promise<any[]> {
    let response = await api.callEndpoint(
      GetBluebeamAccessSettingsResponse,
      "GET",
      `bluebeamaccess/settings`,
      PaginationRequest.noPagination()
    );
    return response.settings;
  }

}

